import { FC } from 'react';
import { useRequestInfoContext } from 'src/common/providers/RequestInfoProvider';
import useFeatureFlag from 'src/common/hooks/useFeatureFlag';
import { AB_TEST_COOKIE_NAME } from 'src/common/constants';
import { AB_TEST } from 'src/common/abTestConfig';
import Typography from '../Typography';
import styles from './AbTestVariantSelector.module.scss';

const SIX_MONTHS_IN_SECONDS = 6 * 31 * 24 * 60 * 60;

const AbTestVariantSelector: FC = () => {
  const { ab } = useRequestInfoContext();
  const abTestsActive = useFeatureFlag('activate-ab-test');

  if (!abTestsActive) {
    return null;
  }

  return (
    <div>
      <Typography type="h2" size="heading-6" weight="semibold" className={styles.text}>
        Active AB Test:
        {' '}
        {AB_TEST.name}
      </Typography>
      <ul className={styles.list}>
        {AB_TEST.variants.map((variant) => (
          <li
            key={variant.id}
            className={styles.item}
          >
            <label
              className={styles.label}
              title={variant.id}
            >
              <input
                type="radio"
                name={AB_TEST_COOKIE_NAME}
                value={variant.code}
                defaultChecked={variant.code === ab}
                onChange={(event) => {
                  document.cookie = `${AB_TEST_COOKIE_NAME}=${event.target.value}; Path=/; Max-Age=${SIX_MONTHS_IN_SECONDS}`;
                }}
              />
              <span>{variant.name}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AbTestVariantSelector;
